// Вставка таблиц: новая таблица из матрицы (с фокусом на названии), вставка данных в существующую таблицу
// с позиции курсора (таблица растёт по необходимости; строки, попавшие в головку, остаются головкой).
import type { Editor } from '@tiptap/core';
import { Fragment, Slice } from '@tiptap/pm/model';
import { TextSelection } from '@tiptap/pm/state';
import { CellSelection, handlePaste } from '@tiptap/pm/tables';
import { insertBlocks, focusInside } from '../../../core/editor/insert';
import { selectedCols, stoTableJson, tableCtx, tableCtxAt, tableNodeFromMatrix, type Matrix } from './model';

/** Вставить новую таблицу. Курсор - в название (или в первую ячейку данных, если название задано). */
export function insertTable(editor: Editor, m: Matrix, caption = '', toCells = false): number {
  const pos = insertBlocks(editor, stoTableJson(m, caption));
  if (toCells) {
    const t = tableCtxAt(editor.state.doc, pos);
    if (t) {
      const rel = t.map.map[0];
      editor.view.dispatch(editor.state.tr.setSelection(TextSelection.create(editor.state.doc, t.tableStart + rel + 2)).scrollIntoView());
      editor.view.focus();
      return pos;
    }
  }
  focusInside(editor, pos);
  return pos;
}

/** Вставить данные в таблицу под курсором (как в Excel: с текущей ячейки, лишние строки/графы добавляются). */
export function pasteIntoTable(editor: Editor, m: Matrix): boolean {
  const t = tableCtx(editor);
  if (!t) return false;
  const rect = selectedCols(editor, t);
  const r0 = rect ? rect.top : 0;
  // выделена одна ячейка - вставлять с неё целиком (иначе prosemirror-tables обрежет данные по выделению)
  if (rect && editor.state.selection instanceof CellSelection && rect.right - rect.left === 1 && rect.bottom - rect.top === 1) {
    const cellPos = t.tableStart + t.map.map[rect.top * t.map.width + rect.left];
    editor.view.dispatch(editor.state.tr.setSelection(TextSelection.create(editor.state.doc, cellPos + 2)));
  }
  const node = tableNodeFromMatrix(editor.schema, m, Math.max(0, t.headerRows - r0));
  return handlePaste(editor.view, null as any, new Slice(Fragment.from(node), 0, 0));
}
